import { mediaAssets, mediaByFolder } from '../generated/media-manifest'
import type { MediaAsset } from '../types'

export const assetsFor = (folders: readonly string[]) =>
  folders.flatMap((folder) => mediaByFolder[folder] ?? [])

export const assetBySource = (source?: string): MediaAsset | undefined =>
  source ? mediaAssets.find((asset) => asset.source === source) : undefined

export const preferredVariant = (asset: MediaAsset, width = 1440) =>
  [...asset.variants].reverse().find((variant) => variant.width <= width) ?? asset.variants.at(-1)!

export const avifSrcSet = (asset: MediaAsset) =>
  asset.variants.map((variant) => `${variant.avif} ${variant.width}w`).join(', ')

export const webpSrcSet = (asset: MediaAsset) =>
  asset.variants.map((variant) => `${variant.webp} ${variant.width}w`).join(', ')
